import { Box } from '@mui/material';
import { DocumentTypeSelection } from '@verifime/components';
import { TIdentityDocumentType } from '@verifime/utils';
import { useEffect, useRef } from 'react';
import { useFileUploaderContext } from './FileUploaderContext';
import { useFormContext } from './FormContext';
import { useScrollTargetContext } from './ScrollTargetContext';
import { useWizardContext } from './WizardContext';
import { useScanContext } from './ScanContext';

export default function DocumentTypeSelectionView({
  currentStep,
}: Readonly<{ currentStep: number }>) {
  const {
    state: { identityDocumentTypeSelections },
    getAvailableDocumentTypesForStep,
    updateIdentityDocumentTypeSelection,
  } = useWizardContext();
  const { registerRef } = useScrollTargetContext();
  const { resetForm } = useFormContext();
  const { resetFileUploader } = useFileUploaderContext();
  const { resetScan } = useScanContext();

  const selectDocumentTypeRef = useRef<HTMLDivElement>(null);

  // Register the ref with ScrollTargetContext
  useEffect(() => {
    registerRef('select-document-type', selectDocumentTypeRef);
  }, [registerRef]);

  const fieldName = `verificationMethod${currentStep}`;

  const handleDocumentTypeSelectionChange = (newDocumentType: TIdentityDocumentType) => {
    updateIdentityDocumentTypeSelection(currentStep, newDocumentType);
    resetForm();
    resetFileUploader();
    resetScan();
  };

  return (
    <Box ref={selectDocumentTypeRef} data-component="DocumentTypeSelectionView">
      <DocumentTypeSelection
        defaultDocumentType={identityDocumentTypeSelections[currentStep]}
        fieldName={fieldName}
        onDocumentTypeChange={handleDocumentTypeSelectionChange}
        supportedDocumentTypes={getAvailableDocumentTypesForStep(currentStep)}
      />
    </Box>
  );
}
